import {
    GET_LIST_PRODUCT_GROUP,
    GET_SPECIFIC_PRODUCT_GROUP,
    UPDATE_SPECIFIC_PRODUCT_GROUP,
    CREATE_NEW_PRODUCT_GROUP,
    REMOVE_PRODUCT_GROUP,
    GET_PRODUCT_GROUP_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    product_group_list: [],
    product_group_active_list: [],
    current_product_group: null,
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PRODUCT_GROUP: {
            return {
                ...state,
                product_group_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_PRODUCT_GROUP_ACTIVE: {
            return {
                ...state,
                product_group_active_list: action.payload.data,
            }
        }
        case GET_SPECIFIC_PRODUCT_GROUP: {
            return { ...state, current_product_group: action.payload }
        }
        case CREATE_NEW_PRODUCT_GROUP: {
            return {
                ...state,
                product_group_list: [action.payload, ...state.product_group_list],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_PRODUCT_GROUP: {
            let index = state.product_group_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.product_group_list];
            temp[index] = action.payload;
            return { ...state, product_group_list: temp }
        }
        case REMOVE_PRODUCT_GROUP: {
            let temp = state.product_group_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });

            return { ...state, product_group_list: temp }
        }
        default: return { ...state };
    }
}
